import { HEADER_PRIMARY_CHANNEL_ID } from 'constants-activate';
import { appUrl } from 'client-config';
import {
  HEADER_VANTIFY_USERNAME,
  HEADER_VANTIFY_PASSWORD,
  HEADER_VANTIFY_BASE_URL,
} from './constants';

export const VANTIFY_API_BASE_PATH = '/api/v6/vantify';

export const VANTIFY_PROXY_ENDPOINT = `${appUrl}${VANTIFY_API_BASE_PATH}`;

export const VANTIFY_UPLOAD_ENDPOINT = `${appUrl}${VANTIFY_API_BASE_PATH}/upload-file`;

export const VANTIFY_HEADERS = {
  PRIMARY_CHANNEL_ID: HEADER_PRIMARY_CHANNEL_ID,
  VANTIFY_USERNAME: HEADER_VANTIFY_USERNAME,
  VANTIFY_PASSWORD: HEADER_VANTIFY_PASSWORD,
  VANTIFY_BASE_URL: HEADER_VANTIFY_BASE_URL,
  AUTHORIZATION: 'Authorization',
};

export const VANTIFY_DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
